import { nanoid } from 'nanoid';
import { Transforms } from 'slate';

import { ELEMENT_IELTS_CALENDAR_COMPUTER_BASED } from './IeltsCalendarComputerBasedPlugin.types';

function addNode(editor: any) {
  Transforms.insertNodes(
    editor,
    [
      {
        id: nanoid(),
        type: ELEMENT_IELTS_CALENDAR_COMPUTER_BASED,
        children: [{ text: '' }],
        isVoid: true,
      },
    ],
    { at: editor.selection }
  );
}

function removeNodeById(editor, elementId) {
  Transforms.removeNodes(editor, { at: [], match: (n: any) => n?.id === elementId });
}

function updateUrl({ editor, elementId, url }) {
  Transforms.setNodes(editor, { url }, { at: [], match: (n: any) => n?.id === elementId });
}

export const ieltsCalendarComputedBasedTransforms = {
  addNode,
  removeNodeById,
  updateUrl,
};
